import React from 'react';
import PropTypes from 'prop-types';
import { PinIcon, CalendarIcon, AlertIcon, TickIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-button';
import { format } from 'date-fns';
import * as styles from '../../styles/homepass-booking/homepass-booking-structure';
import { FORMAT_TIME } from '../homepass-booking';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PREDEFINED_DATE_MESSAGE = 'Your inspection booking is confirmed!';
var CUSTOM_DATE_MESSAGE = 'Your request has been sent to the agent!';
var PREDEFINED_DATE_FOOTER = 'A booking confirmation has also been sent to your email.';
var CUSTOM_DATE_FOOTER = 'The agent will contact you to confirm this booking.';
var ConfirmationPage = props => {
  if (props.isError) {
    var buttonText = "Let's try again later";
    var errorMessage = 'Uh-oh, server issues.';
    return ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: styles.confirmMessage
    }, ___EmotionJSX("span", {
      css: styles.confirmErrorIcon
    }, ___EmotionJSX(AlertIcon, null)), ___EmotionJSX("div", {
      css: styles.confirmErrorText,
      "data-testid": "homepass-booking__confirm-error-text"
    }, errorMessage)), ___EmotionJSX("div", {
      css: styles.confirmFooterText
    }), ___EmotionJSX(Button, {
      onClick: props.onCloseModalCallback
    }, buttonText));
  }
  return ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.confirmMessage
  }, ___EmotionJSX("span", {
    css: styles.confirmMessageIcon
  }, ___EmotionJSX(TickIcon, null)), ___EmotionJSX("div", {
    css: styles.confirmMessageText,
    "data-testid": "homepass-booking__confirm-message-text"
  }, props.isAvailableCalendarEvent ? CUSTOM_DATE_MESSAGE : PREDEFINED_DATE_MESSAGE)), ___EmotionJSX("div", {
    css: styles.confirmDateOrAddress
  }, ___EmotionJSX("span", {
    css: styles.confirmIcon
  }, ___EmotionJSX(CalendarIcon, null)), ___EmotionJSX("div", {
    css: styles.confirmText,
    "data-testid": "homepass-booking__confirm-date-text"
  }, format(new Date(props.startDate), 'dddd, DD MMM'))), ___EmotionJSX("div", {
    css: styles.confirmTimeText
  }, format(new Date(props.startDate), FORMAT_TIME), " -", ' ', format(new Date(props.endDate), FORMAT_TIME)), ___EmotionJSX("div", {
    css: styles.confirmDateOrAddress
  }, ___EmotionJSX("span", {
    css: styles.confirmIcon
  }, ___EmotionJSX(PinIcon, null)), ___EmotionJSX("div", {
    css: styles.confirmText,
    "data-testid": "homepass-booking__confirm-address-text"
  }, props.listingAddress)), ___EmotionJSX("div", {
    css: styles.confirmFooterText
  }, props.isAvailableCalendarEvent ? CUSTOM_DATE_FOOTER : PREDEFINED_DATE_FOOTER), ___EmotionJSX(Button, {
    onClick: props.onCloseModalCallback
  }, "Back to property details"));
};
ConfirmationPage.propTypes = {
  isError: PropTypes.bool.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  listingAddress: PropTypes.string.isRequired,
  onCloseModalCallback: PropTypes.func,
  isAvailableCalendarEvent: PropTypes.bool.isRequired
};
ConfirmationPage.defaultProps = {
  onCloseModalCallback: () => {}
};
export default ConfirmationPage;